import { Link } from "react-router-dom";

const DashboardWidget = ({
  icon: Icon,
  label,
  count,
  link,
  bottomLabel = null,
  showLabelAtBottom = true,
}) => {
  return (
    <Link
      to={link}
      className="flex flex-col justify-between rounded-lg border border-gray-200 bg-white p-4"
    >
      {/* Top section */}
      <div className="flex items-center space-x-2">
        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-shade-1">
          <Icon className="text-lg text-gray-600" />
        </div>
        <span className="text-sm font-medium text-gray-600">{label}</span>
      </div>

      {/* Divider */}
      <hr className="my-2 border-gray-200" />

      {/* Count */}
      <div>
        <p
          className={
            "text-lg font-semibold text-gray-900 w-full block " +
            ((bottomLabel || label) && showLabelAtBottom ? "" : " text-center ")
          }
        >
          {count} {showLabelAtBottom ? (bottomLabel ? bottomLabel : label) : ""}
        </p>
      </div>
    </Link>
  );
};

export default DashboardWidget;
